<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :options="[{ type: 'alert', label: '알림 대상자 선택' }]" />

    <!-- 화학물질 관리대장 -->
    <substance-management-module :readonly="board.readonly" v-model="form.msds" :is-print="isPrint" />

    <!-- 확인자 -->
    <div>
      <div>
        <h5><i class="dot"></i>{{ $t('확인자') }}</h5>
        <p class="py-4" style="color:#696D71;">{{ $t('위 화학물질에 대한 취급내용을 확인 하였습니다.') }}</p>
      </div>
      <div class="writeGridContainer" style="align-items: start">
        <div>
          <div>{{ $t('확인일') }}</div>
          <date-selector v-if="!isPrint" v-model="form.sign.date" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign.date }}</span>
        </div>
        <div>
          <div>{{ $t('관리감독자') }}</div>
          <ml-input v-if="!isPrint" v-model="form.sign.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign.name }}</span>
        </div>
        <div style="align-items: start; ">
          <div class="pt-2">{{ $t('서명') }}</div>
          <sign-field v-if="!isPrint && !board.readonly"  v-model="form.sign.sign" class="w-full flex-1 p-1"/>
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign.sign" :src="form.sign.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
    </div>

    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" />
  </div>
</template>

<script>

import FieldSelectModule from '@/views/modules/FieldSelectModule.vue'
import FileUploadModule from '@/views/modules/FileUploadModule.vue'
import SubstanceManagementModule from '@/views/boards/single-page/399/SubstanceManagementModule.vue'
import SignField from '@/components/SignField.vue'
import DateSelector from '@/components/selector/DateSelector.vue'

export default {
  components: {
    DateSelector,
    SignField,
    SubstanceManagementModule,
    FileUploadModule,
    FieldSelectModule
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object
  },
  watch: {
    board: {
      immediate: true,
      deep: true,
      handler (/*value*/) {}
    },
    value: {
      important: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.$emit('input', value)
      }
    }
  },
  computed: {
    projectInfo () {
      return this.$store.state.project.projectInfo
    },
  },
  data () {
    return {
      form: {
        stdInfo: {},
        msds: [],
        fileList: [],
        sign: {
          date: "",
          name: "",
          sign: "",
        },
      },
    }
  },
  methods: {
  }
}
</script>

<style scoped>

</style>
